import { render, staticRenderFns } from "./TableDiagnosticImage.vue?vue&type=template&id=30c13932"
import script from "./TableDiagnosticImage.vue?vue&type=script&lang=js"
export * from "./TableDiagnosticImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports